<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>   
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
#app {
  font-family: microsoftyahei,"微软雅黑","Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: rgba(34, 34, 34, 0.8);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
  border: 0;
  /* overflow-x: auto; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue